import { HttpClient } from 'shared/libs/http';
import {
   CandidateDeleteCvDto,
   CandidateDeleteCvResponse,
   GetCvListResponse,
   LoadCvPdfDto,
   LoadCvPdfResponse,
} from './types';

export class ManageCvsApiService {
   public static async loadCvs<TDto extends null>(dto: TDto, {}: {}) {
      return await HttpClient.post<GetCvListResponse>('/candidates/getCvList', dto);
   }

   public static async deleteCv<TDto extends CandidateDeleteCvDto>(dto: TDto) {
      return await HttpClient.post<CandidateDeleteCvResponse>(
         '/candidates/deleteCv/' + dto.id,
         dto
      );
   }

   public static async loadCvPdf<TDto extends LoadCvPdfDto>(dto: TDto) {
      return await HttpClient.post<LoadCvPdfResponse>('/download-user-pdf', dto, {
         responseType: 'blob',
      });
   }
}
